module.exports = __webpack_public_path__ + "static/media/stockholm-poster.6e9f53c8.jpg";